<template>
  <div>
    <button class="p-link layout-signout-button">
            <span class="pi pi-backward" v-on:click="openPosition('topright')">
            </span>
    </button>
    <span v-if="getChartCount > 0" class="layout-topbar-badge">{{ getChartCount }}</span>
    <Dialog :header="translate('header.recent.offers')" :modal="true" :position="position" :style="{width: '30vw'}"
            :visible.sync="displayPosition">

      <Listbox :options="getOffers" style="width: 100%; border: none" v-on:change="changeEvent">
        <template #option="slotProps">
          <div style="height: 3rem">
            <span><strong>{{ slotProps.option.label }}</strong></span><br>
            {{ renderDateIntl(slotProps.option.offerDate) }}<br>
            <span v-html="renderOfferStateIntl(slotProps.option.offerState)"></span>
          </div>
        </template>
      </Listbox>

      <!--           <div style="text-align: right"> <Button :label="translate('open.offers')" v-on:click="goTo()" ></Button></div>-->
    </Dialog>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import TranslateService from "../services/translate.service";
import router from "../router";
import {renderDate, renderOfferState} from "@/components/renderer";

export default {
  name: "RecentViewed",
  data() {
    return {
      clickedItem: null,
      displayBasic: false,
      displayBasic2: false,
      displayModal: false,
      displayMaximizable: false,
      displayPosition: false,
      position: 'center'
    }
  },
  computed: {
    ...mapGetters('offer',
        ['getOffers', 'getChartList', 'getChartCount']),
    ...mapGetters('config', ['featureActive']),
  },
  methods: {
    ...mapActions('offer', ['loadOffers']),
    renderDateIntl: renderDate,
    renderOfferStateIntl: renderOfferState,

    changeEvent(event) {
      console.log("Event: ", event);
      if (this.featureActive("externalOffers")) {
        // Wenn offers eine separate APP ist zu dieser Navigieren
        location.href = '/offers/' + event.value.id;
      } else {
        // sonst intern navigieren
        router.push('/offer/' + event.value.id);
      }

      this.displayPosition = false;
    },
    toggle(event) {
      this.$refs.op.toggle(event);
    },
    ...mapActions('offer', [
      'addToOffer', 'deleteChartItem'
    ]),
    openPosition(position) {
      this.loadOffers();
      this.position = position;
      this.displayPosition = true;
    },
    chartItemClick(item) {
      this.clickedItem = item;
      this.deleteChartItem(item)
    },
    translate(message) {
      return TranslateService.translateMessage(message);
    },
  },
  mounted() {
    this.loadOffers();
  }
}
</script>

<style scoped>

.layout-topbar-badge {
  position: absolute;
  font-size: 10px;
  right: 50px;
  top: 5px;
  padding-left: 5px;
  padding-right: 5px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  color: white;
  background-color: #bf2538;
  -moz-border-radius: 50%;
  -webkit-border-radius: 50%;
  border-radius: 50%;
}

</style>